import { get } from '@xmatters/redux/services/httpService';

const STRIPE_ERROR_CODES = new Set([
  'email_invalid',
  'card_decline_rate_limit_exceeded',
  'postal_code_invalid',
  'invalid_expiry_month',
  'expired_card',
  'incorrect_number',
  'incorrect_cvc',
  'incorrect_address',
  'incorrect_zip',
  'invalid_cvc',
  'invalid_expiry_year',
  'invalid_number',
  'processing_error',
]);

const STRIPE_DECLINE_CODES = new Set([
  'insufficient_funds',
  'issuer_not_available',
  'reenter_transaction',
  'testmode_decline',
  'try_again_later',
  'withdrawal_count_limit_exceeded',
  'duplicate_transaction',
  'expired_card',
  'incorrect_number',
  'incorrect_cvc',
  'incorrect_zip',
  'invalid_cvc',
  'invalid_expiry_year',
  'invalid_number',
  'processing_error',
]);

const UNSUPPORTED_CARDS = ['prepaid', 'debit'];

export const convertStripeError = ({ code, decline_code, payment_method }) => {
  if (STRIPE_ERROR_CODES.has(code)) {
    return `STRIPE_${code.toUpperCase()}`;
  }

  if (
    decline_code === 'generic_decline' &&
    UNSUPPORTED_CARDS.includes(payment_method?.card?.funding)
  ) {
    return 'STRIPE_UNSUPPORTED_CARDS_ERROR';
  }

  if (code === 'card_declined') {
    return STRIPE_DECLINE_CODES.has(decline_code)
      ? `STRIPE_${decline_code.toUpperCase()}`
      : 'STRIPE_GENERIC_DECLINE_ERROR';
  }
  return 'STRIPE_GENERIC_ERROR';
};

export const serverError = 'BILLING_PAYMENT_FATAL_ERROR';

const defaultConfigs = {
  retries: 90, // payment processing usually takes 1 minute. Allow extra time before giving up polling
  interval: 2000,
};

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const poll = async (uri, config = defaultConfigs) => {
  const res = await get({ uri });

  if (res.status === 'AWAITING_START_PAYMENT') {
    return new Promise(resolve => resolve(res));
  }

  if (res.status === 'ERROR') {
    throw new Error(res.processData.errorMessage);
  }

  const remainingRetries = config.retries - 1;
  if (remainingRetries < 0) {
    throw new Error(serverError);
  }
  await sleep(config.interval);
  return poll(uri, { ...config, retries: remainingRetries });
};
